import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { markRouteMount, markPaint, summarize } from './tabPerf';

/**
 * Single tracker mounted inside <Routes> that records routeMount + paint
 * for every navigation, and prints the per-tab summary ~1.5s later (long
 * enough to capture the first axios call's apiEnd from services/api.js).
 *
 * No-op when localStorage.tabPerf !== '1'.
 */
const TabPerfTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    markRouteMount(path);

    let paintRaf;
    let summaryTimer;
    if (typeof requestAnimationFrame === 'function') {
      paintRaf = requestAnimationFrame(() => markPaint(path));
    } else {
      markPaint(path);
    }

    summaryTimer = setTimeout(() => summarize(path), 1500);

    return () => {
      if (paintRaf && typeof cancelAnimationFrame === 'function') {
        cancelAnimationFrame(paintRaf);
      }
      clearTimeout(summaryTimer);
    };
  }, [location.pathname]);

  return null;
};

export default TabPerfTracker;
